import React from 'react';

function StockCard({ stock, onClick }) {
  const getPredictionColor = (prediction) => {
    if (typeof prediction === 'object') {
      prediction = prediction.prediction || 'neutral';
    }
    switch (prediction) {
      case 'up':
        return '#10b981';
      case 'down':
        return '#ef4444';
      default:
        return '#6b7280';
    }
  };

  const getPredictionIcon = (prediction) => {
    if (typeof prediction === 'object') {
      prediction = prediction.prediction || 'neutral';
    }
    switch (prediction) {
      case 'up':
        return '📈';
      case 'down':
        return '📉';
      default:
        return '➡️';
    }
  };

  const prediction = typeof stock.prediction === 'object' 
    ? stock.prediction.prediction 
    : stock.prediction;
  const confidence = typeof stock.prediction === 'object' 
    ? stock.prediction.confidence 
    : null;
  const mentions = stock.mentions || { total_mentions: stock.mention_count || 0 };

  return (
    <div className="stock-card" onClick={onClick}>
      <div className="stock-header">
        <h2>{stock.symbol}</h2>
        <span
          className="prediction-badge"
          style={{ backgroundColor: getPredictionColor(prediction) }}
        >
          {getPredictionIcon(prediction)} {prediction.toUpperCase()}
          {confidence && ` ${confidence}%`}
        </span>
      </div>
      
      <div className="stock-name">{stock.name}</div>
      
      <div className="stock-price">
        <span className="price">${stock.current_price?.toFixed(2) || '0.00'}</span>
        <span
          className={`price-change ${
            stock.price_change >= 0 ? 'positive' : 'negative'
          }`}
        >
          {stock.price_change >= 0 ? '+' : ''}
          {stock.price_change?.toFixed(2) || '0.00'} ({stock.price_change_percent >= 0 ? '+' : ''}
          {stock.price_change_percent?.toFixed(2) || '0.00'}%)
        </span>
      </div>

      <div className="stock-stats">
        <div className="stat">
          <span className="stat-label">Total Mentions:</span>
          <span className="stat-value">{mentions.total_mentions || 0}</span>
        </div>
        <div className="stat">
          <span className="stat-label">Volume:</span>
          <span className="stat-value">
            {(stock.volume / 1000000).toFixed(2)}M
          </span>
        </div>
      </div>

      {mentions.hype_score !== undefined && mentions.real_score !== undefined && (
        <div className="hype-real-indicator">
          <div className="hype-real-bar">
            <div 
              className="hype-bar" 
              style={{ 
                width: `${(mentions.hype_score / Math.max(mentions.hype_score + mentions.real_score, 1)) * 100}%` 
              }}
            >
              <span>Hype: {mentions.hype_score}</span>
            </div>
            <div 
              className="real-bar" 
              style={{ 
                width: `${(mentions.real_score / Math.max(mentions.hype_score + mentions.real_score, 1)) * 100}%` 
              }}
            >
              <span>Real: {mentions.real_score}</span>
            </div>
          </div>
        </div>
      )}

      {stock.last_updated && (
        <div className="last-updated">
          Updated: {new Date(stock.last_updated).toLocaleTimeString()}
        </div>
      )}
    </div>
  );
}

export default StockCard;

